import homeRunClassifier from '../classificators/homeRunClassifier.js';
import hitClassifier from '../classificators/hitClassifier.js';
import strikeOutClassifier from '../classificators/strikeOutClassifier.js';
import PitchData from '../enums/PitchData.js';
import ResultData from '../enums/ResultData.js';

const filterOnlyHits = function(){
    return [{parameter: ResultData.getDataPath(PitchData.Result.key), operator: 'function', value: hitClassifier}];
};

const filterOnlyStrikeOuts = function(){
    return [{parameter: ResultData.getDataPath(PitchData.Result.key), operator: 'function', value: strikeOutClassifier}];
};

const filterOnlyHomeRuns = function(){
    return [{parameter: ResultData.getDataPath(PitchData.Result.key), operator: 'function', value: homeRunClassifier}];
};

export {
    filterOnlyHits, filterOnlyStrikeOuts, filterOnlyHomeRuns
};